"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripePaymentOptionsProvider = exports.useStripePaymentOptions = void 0;
const React = require("react");
const react_1 = require("react");
const StripePaymentRequestProvider_1 = require("./StripePaymentRequestProvider");
const StripePromiseProvider_1 = require("../StripePromiseProvider");
const useClient_1 = require("../../../../../hooks/useClient");
const StripePaymentNativeOptions_1 = require("./StripePaymentNativeOptions");
const SavedPaymentProvider_1 = require("../Hooks/SavedPaymentProvider");
const ConfirmationDialog_1 = require("../BasicComponents/ConfirmationDialog");
const stripePaymentOptionsContext = (0, react_1.createContext)(undefined);
const useStripePaymentOptions = () => {
    const context = (0, react_1.useContext)(stripePaymentOptionsContext);
    if (context === undefined) {
        throw new Error("useAppContext must be used within an AppProvider");
    }
    return context;
};
exports.useStripePaymentOptions = useStripePaymentOptions;
const StripePaymentOptionsProvider = ({ children }) => {
    //spg-common contexts
    const client = (0, useClient_1.useClient)();
    const { Connected, ShowNativeCardEntry, ActiveMethods } = (0, StripePaymentNativeOptions_1.useStripeNativeOptions)();
    const retailCustomerId = (0, react_1.useMemo)(() => client.auth.session &&
        client.auth.session.retailCustomer &&
        client.auth.session.retailCustomer.id, [client.auth.session]);
    //stripe contexts
    const showConfirmation = (0, ConfirmationDialog_1.useConfirmation)();
    const { selectedPaymentId, setSelectedPaymentId, error } = (0, SavedPaymentProvider_1.useSavedPayment)();
    const [loadingState, setLoadingState] = (0, react_1.useState)("Initial");
    const stripe = (0, StripePromiseProvider_1.useStripePromise)();
    const { supportedMethods, confirmPayment: showPaymentRequest } = (0, StripePaymentRequestProvider_1.useStripePaymentRequest)();
    const [currentStatus, setCurrentStatus] = (0, react_1.useState)(selectedPaymentId ? "OVERVIEW" : "SELECT_PAYMENT_METHODS");
    const [paymentMethods, setPaymentMethods] = (0, react_1.useState)([]);
    const [nativePaymentMethods, setNativePaymentMethods] = (0, react_1.useState)([]);
    // const [selectedOption, setSelectedOption] = useSavedPaymentId();
    const handleProcessPayment = async () => {
        if (!stripe)
            return;
    };
    const CheckNativeSupportedMethods = async () => {
        let validMethods = [];
        if (supportedMethods.ApplePay) {
            validMethods.push({
                isPaymentRequest: true,
                id: "applePay",
                icon: "applePay",
                name: "Apple Pay"
            });
        }
        if (supportedMethods.GooglePay) {
            validMethods.push({
                isPaymentRequest: true,
                id: "googlePay",
                icon: "googlePay",
                name: "Google Pay"
            });
        }
        setNativePaymentMethods(validMethods);
    };
    const CheckSupportedPaymentMethods = async () => {
        //check for native supported methods
        if (!stripe)
            return;
        setLoadingState("Loading");
        //fetch server methods
        const userMethods = await client.retailCustomers.retrieveActivePaymentMethods(retailCustomerId);
        const currentMethods = userMethods !== null && userMethods !== void 0 ? userMethods : [];
        let validMethods = [];
        try {
            for (let method of currentMethods) {
                validMethods.push({
                    id: method.id,
                    name: method.name,
                    type: method.name,
                    description: method.description
                });
            }
        }
        catch (e) {
            console.log(e);
        }
        setPaymentMethods(validMethods);
        setLoadingState("Loaded");
    };
    (0, react_1.useEffect)(() => {
        CheckSupportedPaymentMethods();
    }, []);
    (0, react_1.useEffect)(() => {
        CheckNativeSupportedMethods();
    }, [supportedMethods]);
    const deletePaymentMethod = async (methodId) => {
        let confirmResult = await showConfirmation({
            message: "Are you sure you want to delete this payment method?",
            title: "Delete Payment Method",
            ShowButtons: true
        });
        if (confirmResult) {
            const userMethods = await client.retailCustomers.removeActivePaymentMethod(retailCustomerId, methodId);
            setSelectedPaymentId("");
            await CheckSupportedPaymentMethods();
            //call the delete method
        }
    };
    const addNewPaymentMethod = async () => {
        let nonPaymentMethods = (paymentMethods !== null && paymentMethods !== void 0 ? paymentMethods : []).filter(x => !x.isPaymentRequest);
        if (nonPaymentMethods.length >= 4) {
            let confirmResult = await showConfirmation({
                message: "You cannot exceed four payment methods!",
                title: "Warning",
                ShowButtons: false
            });
            return;
        }
        if (Connected && retailCustomerId) {
            let result = await client.retailCustomers.setupActivePaymentMethod(retailCustomerId);
            if (result.setupSecret) {
                const setupResult = await ShowNativeCardEntry(result.setupSecret);
                if (setupResult.Success && setupResult.PaymentMethodId) {
                    await CheckSupportedPaymentMethods();
                    handleSelectPayment(setupResult.PaymentMethodId);
                }
            }
            return;
        }
        setCurrentStatus("ADD_PAYMENT_METHOD");
    };
    const completeAddPayment = (methodId) => {
        //do something if the method id is set
        setCurrentStatus("SELECT_PAYMENT_METHODS");
        CheckSupportedPaymentMethods();
    };
    const handleSelectPayment = (methodId) => {
        setSelectedPaymentId(methodId);
        setCurrentStatus("OVERVIEW");
    };
    const handleChangePayment = () => {
        setCurrentStatus("SELECT_PAYMENT_METHODS");
    };
    const currentContext = {
        loadingState: loadingState,
        currentStatus: currentStatus,
        paymentMethods: [...nativePaymentMethods, ...paymentMethods],
        currentPaymentMethod: selectedPaymentId,
        selectPaymentMethod: handleSelectPayment,
        removePaymentMethod: deletePaymentMethod,
        addNewPaymentMethod: addNewPaymentMethod,
        completeAddPayment: completeAddPayment,
        handleChangePayment: handleChangePayment,
        handlePlaceOrder: handleProcessPayment
    };
    return (React.createElement(stripePaymentOptionsContext.Provider, { value: currentContext }, children));
};
exports.StripePaymentOptionsProvider = StripePaymentOptionsProvider;
//# sourceMappingURL=StripePaymentOptionsProvider.js.map